export default __webpack_public_path__ + "static/media/fw-zoe-er-White Gold.97c71c37.mp4";